import { useMemo } from "react";

export const RunnerConfigurationKeys = {
    AWSInstanceType: "instanceType",
    DiskSizeGB: "diskSizeGB",
    CPU: "cpu",
    Memory: "memory",
    SpotInstanceEnabled: "spot",
};

export const AWSRunnerAdditionalFieldsKeys = {
    AWSAccountID: "awsAccountID",
    StackURL: "awsCloudFormationStackURL",
    StackName: "awsCloudFormationStackName",
    Region: "region",
    LogURL: "logURL",
    RunnerProxyDomain: "runnerProxyDomain",
    RunnerTemplateBuildVersion: "runnerTemplateBuildVersion",
    UsingPrivateConnection: "usingPrivateConnection",
    ApiEndpoint: "apiEndpoint",
};

export const LinuxRunnerAdditionalFieldsKeys = {
    OS: "os",
    RootDiskSize: "rootDiskSize",
    HomeDiskSize: "homeDiskSize",
    Kernel: "kernel",
    Cores: "cores",
    Memory: "memory",
    Hostname: "hostname",
};

export const GCPRunnerAdditionalFieldsKeys = {
    Region: "region",
    ProjectID: "projectID",
    Zones: "zones",
    RunnerLogsURL: "runnerLogsURL",
    RunnerProxyDomain: "runnerProxyDomain",
    RunnerTemplateBuildVersion: "runnerTemplateBuildVersion",
    ApiEndpoint: "apiEndpoint",
};

/**
 * Custom hook to extract the hostname from an API endpoint URL.
 * Returns null if the endpoint is empty or invalid.
 */
export const useApiEndpointHost = (apiEndpoint: string): string | null => {
    return useMemo(() => {
        if (!apiEndpoint) {
            return null;
        }

        try {
            const url = new URL(apiEndpoint);
            return url.host;
        } catch (e) {
            console.error("Invalid API endpoint URL:", apiEndpoint, e);
            return null;
        }
    }, [apiEndpoint]);
};

/**
 * Generates connection type text based on API endpoint and connection type.
 */
export const getConnectionTypeText = (
    apiEndpointHost: string | null,
    usingPrivateConnection?: boolean,
): string => {
    if (!apiEndpointHost) {
        return usingPrivateConnection ? "Connected via VPC Endpoint" : "Connected via Direct Connection";
    }
    const connectionType = usingPrivateConnection ? "VPC Endpoint" : "Direct Connection";
    return `Connected via ${connectionType} to ${apiEndpointHost}`;
};
